/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import './EditShareCardButton.styles.scss';

import ShareCardModel from '../../../../models/ShareCardModel';
import { Small } from '../../../components/Text';
import { TextLink } from '../../../components/TextLink';

interface Props {
  onClick(): void;
  shareCard: ShareCardModel;
}
class EditShareCardButton extends React.Component<Props> {
  constructor(props) {
    super(props);
    this.launchEditView = this.launchEditView.bind(this);

    this.state = {
      showModal: false,
    };
  }

  launchEditView(event) {
    event.stopPropagation();
    this.setState({
      showModal: true,
    });
  }

  render() {
    return (
      <div className="edit-share-card-button">
        <TextLink onClick={this.props.onClick}>
          <Small color="dark-neutral" textTransform="uppercase">
            <FormattedMessage id="share.editCard.button.label" />
          </Small>
        </TextLink>
      </div>
    );
  }
}


export default EditShareCardButton;
